import React, { useState } from 'react';
import { FiX, FiEdit, FiCopy, FiCalendar, FiShare } from 'react-icons/fi';

interface RouteActionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  route: any;
}

const RouteActionsModal: React.FC<RouteActionsModalProps> = ({ isOpen, onClose, route }) => {
  const [loading, setLoading] = useState(false);

  const handleEdit = async () => {
    setLoading(true);
    try {
      // TODO: Реализовать редактирование маршрута
      console.log('Edit route:', route?.id);
      await new Promise(resolve => setTimeout(resolve, 1000));
      onClose();
    } catch (error) {
      console.error('Error editing route:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    setLoading(true);
    try {
      // TODO: Реализовать копирование маршрута
      console.log('Copy route:', route?.id);
      await new Promise(resolve => setTimeout(resolve, 1000));
      onClose();
    } catch (error) {
      console.error('Error copying route:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleShiftDates = async () => {
    setLoading(true);
    try {
      // TODO: Реализовать сдвиг дат
      console.log('Shift dates for route:', route?.id);
      await new Promise(resolve => setTimeout(resolve, 1000));
      onClose();
    } catch (error) {
      console.error('Error shifting dates:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleShare = async () => {
    setLoading(true);
    try {
      // TODO: Реализовать поделиться маршрутом
      console.log('Share route:', route?.id);
      await new Promise(resolve => setTimeout(resolve, 1000));
      onClose();
    } catch (error) {
      console.error('Error sharing route:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Заголовок */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Действия с маршрутом</h2>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50"
          >
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Содержимое */}
        <div className="p-6">
          <div className="space-y-3">
            <button
              onClick={handleEdit}
              disabled={loading}
              className="w-full flex items-center space-x-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-50"
            >
              <FiEdit className="w-5 h-5 text-gray-500" />
              <span className="text-gray-700">Редактировать маршрут</span>
            </button>

            <button
              onClick={handleCopy}
              disabled={loading}
              className="w-full flex items-center space-x-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-50"
            >
              <FiCopy className="w-5 h-5 text-gray-500" />
              <span className="text-gray-700">Копировать маршрут</span>
            </button>

            <button
              onClick={handleShiftDates}
              disabled={loading}
              className="w-full flex items-center space-x-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-50"
            >
              <FiCalendar className="w-5 h-5 text-gray-500" />
              <span className="text-gray-700">Сдвинуть даты</span>
            </button>

            <button
              onClick={handleShare}
              disabled={loading}
              className="w-full flex items-center space-x-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-50"
            >
              <FiShare className="w-5 h-5 text-gray-500" />
              <span className="text-gray-700">Поделиться маршрутом</span>
            </button>
          </div>
        </div>

        {/* Подвал */}
        <div className="flex justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouteActionsModal;
